import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d542c6whs7: FaireBrandEntity = {
  token: "b_d542c6whs7",
  type: "brand",
  name: "Blaynk",
  avatarUrl: "https://cdn.faire.com/fastly/43e3cf838c75578e499270b05df0ae431214d8d2d7c0df1fda053bf8d2258439.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/d655751f1a68cecd6d47e66f3928f6407cf15055c078876864f31766b2990596.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/43e3cf838c75578e499270b05df0ae431214d8d2d7c0df1fda053bf8d2258439.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/d655751f1a68cecd6d47e66f3928f6407cf15055c078876864f31766b2990596.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 30,
  isInsider: true,
  description: "The fabrics most of us wrap ourselves in everyday have been treated with countless chemicals (yep, even the organic ones). Blaynk baby fabrics and bed sheets are made with just three things: organic cotton, harvested rainwater for processing, and wind powered factories. Nothing else.\n\nWe grew up in and around the fabric industry. After years spent examining the manufacturing and seeing its chemical underbelly, we knew there had to be a higher standard for the fabrics that surround our lives.\n\nSo: We got to work on a way better way to make bed sheets and baby fabrics. The final product is a win-win-win: for you, your baby and the planet.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.510Z",
    importedBy: "entity-db-cli"
  }
};
